import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegistrationPage from "./pages/RegistrationPage";
import { useQuery } from "@tanstack/react-query";
import ConferenceRegPage from "./pages/ConferenceRegPage";
import { Toaster } from "react-hot-toast";
import AboutCityPage from "./pages/AboutCityPage";
import Loader from "@mui/material/CircularProgress";
import NationalAdvisoryCommittee from "./pages/NationalAdvisoryCommitteePage";
import ScientificAdvisoryCommittee from "./pages/ScientificAdvisoryCommittee";
import OrganizingCommittee from "./pages/OrganizingCommittee";
import AboutIIS from "./pages/AboutIIS";
import ProgramSchedule from "./pages/ProgramSchedule";
import AboutMnnit from "./pages/AboutMnnit";
import OrganizingDept from "./pages/OrganizingDept";
import PastConferences from "./pages/PastConferences";
import AboutThisImmunocon from "./pages/AboutThisImmunocon";
import OtpPage from "./pages/OtpPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Senior_Scientist_Award from "./pages/Senior_Scientist_Award";
import Mid_Career_Scientist_Award from "./pages/Mid_Career_Scientist_Award";
import GP_Talwar_Young_Scientist_Awards from "./pages/GP_Talwar_Young_Scientist_Awards";
import Student_Travel_Bursaries from "./pages/Student_Travel_Bursaries";
import Translational_Immunol_Academia_Industry_Award from "./pages/Translational_Immunol_Academia_Industry_Award";
import Immunocon_2025_Travel_Awards from "./pages/Immunocon_2025_Travel_Awards";
import Poster_Presentation_Awards from "./pages/Poster_Presentation_Awards";
import LocalAdvisory from "./pages/LocalAdvisory";
import Footer from "./components/Footer/Footer";
import WebTeamPage from "./pages/WebTeamPage";
import Accommodation from "./pages/Accommodation";
import SponsorPage from "./pages/SponsorPage";

function App() {
  const API_URL = process.env.REACT_APP_API_URL

  const { data: authUser, isLoading } = useQuery({
    queryKey: ["authUser"],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/auth/me`, {
        method: "GET",
        credentials: "include",
      });
      const data = await res.json();
      if (data.error) return null;
      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }
      return data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <Loader sx={() => ({ color: "#4f46e5" })} />
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/login"
          element={!authUser ? <LoginPage /> : <Navigate to="/conference-registration" />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />}/>
        <Route
          path="/register"
          element={!authUser ? <RegistrationPage /> : <Navigate to="/conference-registration" />}
        />
        <Route path="/verify-otp" element={!authUser ? <OtpPage /> : <Navigate to="/conference-registration" />} />
        <Route
          path="/conference-registration/*"
          element={authUser ? <ConferenceRegPage />: <Navigate to="/login"/> }
        />
        <Route path="/about/prayagraj" element={<AboutCityPage />} />
        <Route path="/committee/national-advisory" element={<NationalAdvisoryCommittee />} />
        <Route path="/committee/scientific-program-advisory" element={<ScientificAdvisoryCommittee />} />
        <Route path="/committee/organizing" element={<OrganizingCommittee />} />
        <Route path="/about/iis" element={<AboutIIS />} />
        <Route path="/program-schedule" element={<ProgramSchedule />} />
        <Route path="/about/mnnit" element={<AboutMnnit />} />
        <Route path="/about/organizing-department" element={<OrganizingDept />}/>
        <Route path="/about/past-conferences" element={<PastConferences />}/>
        <Route path="/about/immunocon-2025" element={<AboutThisImmunocon />}/>
        <Route path="/senior-scientist" element={<Senior_Scientist_Award/>}/>
        <Route path="/mid-career" element={<Mid_Career_Scientist_Award/>}/>
        <Route path="/gp-talwar" element={<GP_Talwar_Young_Scientist_Awards/>}/>
        <Route path="/student-travel" element={<Student_Travel_Bursaries/>}/>
        <Route path="/translational" element={<Translational_Immunol_Academia_Industry_Award/>}/>
        <Route path="/travel-awards" element={<Immunocon_2025_Travel_Awards/>}/>
        <Route path="/poster-presentation" element={<Poster_Presentation_Awards/>}/>
        <Route path="/local-advisory" element={<LocalAdvisory/>}/>
        <Route path="/web-team" element={<WebTeamPage/>}/>
        <Route path="/accommodation" element={<Accommodation />}/>
        <Route path="/sponsor" element={<SponsorPage />}/>
      </Routes>
      <Toaster />
      <Footer/>
    </div>
  );
}

export default App;
